import React, { MouseEventHandler } from "react";
import Link from "../link";

interface TypeAheadOptionProps {
  id: string;
  href?: string;
  title?: string;
  flexSearch: boolean;
  onClick?: (id: string, flexSearch: boolean) => void;
}

const TypeaheadOption: React.FC<TypeAheadOptionProps> = (props) => {
  const handleClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (props.onClick) {
      event.preventDefault();
      props.onClick(props.id, props.flexSearch);
    }
  };

  return (
    <Link
      internal
      href={typeof props.onClick === "undefined" ? props.href : undefined}
      title={props.title}
      className="typeahead__option typeahead__option--icon"
      onClick={handleClick}
    >
      {props.children}
    </Link>
  );
};

export default TypeaheadOption;
